// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"012127bc","33":"c93bf6eb","253":"1fc3b00b","368":"0ec761ba","453":"258b012d","591":"dc859223","685":"248782ba","722":"43dfad41","791":"746ddf73","801":"1e111576","966":"6b4410da"}[chunkId] + ".chunk.js";
};